import type { UiThemeTable } from "./types";

const VAR_PREFIX = "--ui-";

/** Inject theme.json tokens as CSS custom properties on a host element. */
export function applyTheme(host: HTMLElement, theme: UiThemeTable): void {
  const setGroup = (group: string, map: Record<string, string>) => {
    for (const [key, value] of Object.entries(map)) {
      host.style.setProperty(`${VAR_PREFIX}${group}-${key}`, value);
    }
  };
  setGroup("space", theme.spacing);
  setGroup("radius", theme.radius);
  setGroup("font", theme.fontSize);
  setGroup("color", theme.color);
}
